/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRecurringAvailableTractor.ts     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/recurring-available-tractor";

export class AutogenModelRecurringAvailableTractor<RowType extends ModelRow> extends Endpoint<RowType, RowRecurringAvailableTractorFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowRecurringAvailableTractor extends ModelRow<RowRecurringAvailableTractorFields> {
	constructor(values?: Partial<RowRecurringAvailableTractorFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowRecurringAvailableTractorFields {
	carrier_id: string;
	city_id: number;
	comments: string;
	company_id: string;
	contact_email: string;
	contact_fax: string;
	contact_name: string;
	contact_phone: string;
	dispatcher_user_id: string;
	distance_radius: number;
	end_date: Date;
	equipment_type_id_friday: string;
	equipment_type_id_monday: string;
	equipment_type_id_saturday: string;
	equipment_type_id_sunday: string;
	equipment_type_id_thursday: string;
	equipment_type_id_tuesday: string;
	equipment_type_id_wednesday: string;
	expire_day: string;
	id: number;
	load_to_city: string;
	load_to_state: string;
	location_city: string;
	location_state: string;
	location_zip: string;
	sequence: number;
	start_date: Date;
	status: string;
	teams_friday: string;
	teams_monday: string;
	teams_saturday: string;
	teams_sunday: string;
	teams_thursday: string;
	teams_tuesday: string;
	teams_wednesday: string;
	tractors_available_friday: number;
	tractors_available_monday: number;
	tractors_available_saturday: number;
	tractors_available_sunday: number;
	tractors_available_thursday: number;
	tractors_available_tuesday: number;
	tractors_availablewednesday: number;
}

